import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VersionService, SolarData, SolarHistoryPoint, DayStat } from '../version.service';
import { formatW, formatKwh } from '../shared/format.utils';

@Component({
  selector: 'app-energie',
  templateUrl: './energie.component.html',
})
export class EnergieComponent {
  @Input() solar:           SolarData | null        = null;
  @Input() solarHistory:    SolarHistoryPoint[]     = [];
  @Input() solarFlash       = false;
  @Input() liveDotOn        = true;
  @Input() solarUpdatedAt:  number | null           = null;
  @Input() nowTick          = Date.now();
  @Input() todayStat:       DayStat | null          = null;
  @Input() darkMode         = false;

  @Output() openSolarChart  = new EventEmitter<void>();

  constructor(readonly translate: TranslateService, readonly vs: VersionService) {}

  formatW  = formatW;
  formatKwh = formatKwh;

  updatedAgo(ts: number | null): string {
    if (ts === null) return '';
    const s = Math.floor((this.nowTick - ts) / 1000);
    if (s < 60)   return `${s}s`;
    if (s < 3600) return `${Math.floor(s / 60)}min`;
    return `${Math.floor(s / 3600)}h`;
  }

  batteryRuntime(solar: SolarData): string {
    if (!solar.batteryCapacityWh) return '';
    if (solar.batteryDischargeW > 0) {
      const hours = (solar.batteryPercent / 100 * solar.batteryCapacityWh) / solar.batteryDischargeW;
      const label = this.translate.instant('AKKU_REST');
      if (hours < 1)  return `${label} ≈ < 1 h`;
      if (hours < 24) return `${label} ≈ ${Math.round(hours)} h`;
      const days = Math.round(hours / 24);
      return `${label} ≈ ${days} ${days === 1 ? this.translate.instant('AKKU_TAG') : this.translate.instant('AKKU_TAGE')}`;
    }
    if (solar.batteryDischargeW < 0) {
      const chargeW     = -solar.batteryDischargeW;
      const remainingWh = (100 - solar.batteryPercent) / 100 * solar.batteryCapacityWh;
      const hours       = remainingWh / chargeW;
      const label       = this.translate.instant('AKKU_VOLL');
      if (hours < 1/60) return `${label} ≈ < 1 min`;
      if (hours < 1)    return `${label} ≈ ${Math.round(hours * 60)} min`;
      return `${label} ≈ ${Math.round(hours)} h`;
    }
    return '';
  }
}
